interface CloseIconProps {
    className?: string;
    onClick?: () => void;
}

export function CloseIcon({ className, onClick }: CloseIconProps) {
    return (
        <svg 
            width="40" 
            height="40" 
            viewBox="0 0 40 40" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            onClick={onClick}
        >
            <path d="M39.8 0V40H0V0H39.8ZM2.33302 37.667H37.467V2.33301H2.33302V37.667Z" fill="currentColor"/>
            <path d="M10.3531 10.4532C11.1557 9.65066 12.4568 9.65066 13.2593 10.4532L29.445 26.6389C30.2476 27.4414 30.2476 28.7425 29.445 29.5451C28.6425 30.3476 27.3413 30.3476 26.5388 29.5451L10.3531 13.3594C9.55061 12.5569 9.55061 11.2557 10.3531 10.4532Z" fill="currentColor"/>
            <path d="M10.3531 29.545C9.55057 28.7425 9.55057 27.4413 10.3531 26.6388L26.5388 10.4531C27.3413 9.65058 28.6425 9.65058 29.445 10.4531C30.2475 11.2556 30.2475 12.5568 29.445 13.3593L13.2593 29.545C12.4568 30.3475 11.1556 30.3475 10.3531 29.545Z" fill="currentColor"/>
        </svg>
    );
}